import React, { useState } from "react";
import Navbar from "../components/Navbar";
import appIcon from "../assets/PupHub.png";
import partnerIcon from "../assets/puphub_partner.png";
import thumbnail from "../assets/Thumbnail.png";
import DailyDostlogo from "../assets/DailyDostlogo.png";
const Product: React.FC = () => {
  const [videoLoaded, setVideoLoaded] = useState<boolean>(false);

  return (
    <>
      <div className="relative w-full min-h-screen overflow-hidden">
        <Navbar />
        {/* Dark gradient video background */}
        <div className="absolute top-0 left-0 w-full h-full">
          {!videoLoaded && (
            <img
              src={thumbnail}
              alt="Loading..."
              className="w-full h-full object-cover"
            />
          )}
          <video
            autoPlay
            loop
            muted
            playsInline
            className="w-full h-full object-cover"
            onLoadedData={() => setVideoLoaded(true)}
            onError={(e) => {
              console.error("Error loading video:", e);
            }}
          >
            <source src="https://apexium.s3.ap-south-1.amazonaws.com/static/videos/Home-Video.mp4" type="video/mp4" />
          </video>
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 to-black/70"></div>
        </div>
        <div className="relative z-10 flex flex-col items-center justify-center min-h-screen px-8 py-20">
          <h1 className="text-4xl font-bold mb-12 text-center text-white">
            Explore Our Products
          </h1>

          {/* PupHub Product Card */}
          <div className="bg-gray-100 shadow-lg rounded-lg max-w-4xl w-full mb-8 p-6">
            <h3
              className="text-4xl  text-black mb-6 text-center"
              style={{
                fontFamily: "'Alfa Slab One', 'Bebas Neue', sans-serif",
              }}
            >
              PupHub
            </h3>
            <div className="flex flex-col md:flex-row md:items-center">
              <img src={appIcon} alt="PupHub" className="w-32 h-32 mx-auto md:mx-0 md:mr-6 mb-4 md:mb-0" />
              <div className="flex-1">
                <p className="text-gray-700 mb-4 text-center md:text-left">
                  To learn more about PupHub and explore its features, click the
                  buttons to visit PupHub website or directly download PupHub
                  app from the Play Store.
                </p>
                <div className="flex flex-col sm:flex-row sm:space-x-4 space-y-2 sm:space-y-0 justify-center md:justify-start">
                  <a
                    href="https://www.puphub.co.in/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <button className="bg-black text-white px-6 py-2 rounded hover:bg-gray-800 w-full sm:w-auto">
                      Visit Website
                    </button>
                  </a>
                  <a
                    href="https://play.google.com/store/apps/details?id=com.puphub"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <button className="bg-black text-white px-6 py-2 rounded hover:bg-gray-800 w-full sm:w-auto">
                      Download
                    </button>
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* DailyDost Product Card */}
          <div className="bg-gray-100 shadow-lg rounded-lg max-w-4xl w-full mb-8 p-6">
            <h3
              className="text-3xl  bg-gradient-to-r from-blue-500 to-yellow-500 bg-clip-text text-transparent mb-6 text-center"
              style={{
                fontFamily: "'Alfa Slab One', 'Bebas Neue', sans-serif",
              }}
            >
              <span style={{ color: "#287C91" }}>Daily</span>
              <span style={{ color: "#E3A80E" }}>Dost</span>
            </h3>
            <div className="flex flex-col md:flex-row md:items-center">
              <img
                src={DailyDostlogo}
                alt="DailyDost"
                className="w-32 h-32 mx-auto md:mx-0 md:mr-6 mb-4 md:mb-0"
              />
              <div className="flex-1">
                <p className="text-gray-700 mb-4 text-center md:text-left">
                  Your daily companion for productivity and wellness. Organize
                  tasks, boost productivity, and maintain your well-being with
                  smart tools and insights.
                </p>
                <div className="flex flex-col sm:flex-row sm:space-x-4 space-y-2 sm:space-y-0 justify-center md:justify-start">
                  <a href="https://dailydost.apexiumtechnologies.co.in">
                    <button
                      className="text-white px-6 py-2 rounded transition-colors duration-300 w-full sm:w-auto"
                      style={{ backgroundColor: "#287C91" }}
                      onMouseOver={(e) =>
                        (e.currentTarget.style.backgroundColor = "#1f6678")
                      }
                      onMouseOut={(e) =>
                        (e.currentTarget.style.backgroundColor = "#287C91")
                      }
                    >
                      Visit Website
                    </button>
                  </a>

                  <a
                    href="https://play.google.com/store/apps/details?id=com.DailyDost"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <button
                      className="text-white px-6 py-2 rounded transition-colors duration-300 w-full sm:w-auto"
                      style={{ backgroundColor: "#287C91" }}
                      onMouseOver={(e) =>
                        (e.currentTarget.style.backgroundColor = "#1f6678")
                      }
                      onMouseOut={(e) =>
                        (e.currentTarget.style.backgroundColor = "#287C91")
                      }
                    >
                      Download
                    </button>
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* PupHub Partner Product Card */}
          <div className="bg-gray-100 shadow-lg rounded-lg max-w-4xl w-full p-6">
            <h3
              className="text-3xl  text-blue-600 mb-6 text-center"
              style={{
                fontFamily: "'Alfa Slab One', 'Bebas Neue', sans-serif",
              }}
            >
              PupHub Partner
            </h3>
            <div className="flex flex-col md:flex-row md:items-center">
              <img
                src={partnerIcon}
                alt="PupHub Partner"
                className="w-32 h-32 mx-auto md:mx-0 md:mr-6 mb-4 md:mb-0"
              />
              <div className="flex-1">
                <p className="text-gray-700 mb-4 text-center md:text-left">
                  PupHub Partner is our business solution for pet service
                  providers. Manage your services, connect with customers, and
                  grow your business through our platform.
                </p>
                <div className="flex flex-col sm:flex-row sm:space-x-4 space-y-2 sm:space-y-0 justify-center md:justify-start">
                  <a
                    href="https://puphub.co.in/partner"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <button className="bg-blue-900 text-white px-6 py-2 rounded hover:bg-blue-800 w-full sm:w-auto">
                      Visit Website
                    </button>
                  </a>
                  <a
                    href="https://play.google.com/store/apps/details?id=com.PupHubPartner"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <button className="bg-blue-900 text-white px-6 py-2 rounded hover:bg-blue-800 w-full sm:w-auto">
                      Download
                    </button>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Dark Footer */}
      <footer className="bg-gray-900 py-6 text-center">
        <p className="text-gray-400">
          © 2025 Apexium Technologies – All Rights Reserved.
        </p>
      </footer>
    </>
  );
};

export default Product;
